var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgSwitch = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ viewBox: "-6 -6 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M10 2.5v3.333h7.5V7.5H3.333L10 2.5ZM10 17.5v-4.167H2.5v-1.666h14.167L10 17.5Z", fill: "currentColor" }));
export { SvgSwitch as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItNiAtNiAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMi41djMuMzMzaDcuNVY3LjVIMy4zMzNMMTAgMi41Wk0xMCAxNy41di00LjE2N0gyLjV2LTEuNjY2aDE0LjE2N0wxMCAxNy41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
